import { ChargeInterface } from "@/interface/business/order.interface";
import { TaxInterface } from "@/interface/business/item.interface";
import { CHARGE_TYPES } from "@/enums/business.enum";
import { ChargeType } from "@/types/orders";
import { Tax } from "@/modules/location";

export default class Charge implements ChargeInterface {
  id: string = "";
  name: string = "";
  rate: number = 0;
  amount: number = 0;
  tax?: TaxInterface;
  type: string = CHARGE_TYPES.PERCENTAGE;

  constructor(data: ChargeType) {
    Object.assign(this, data);

    if (data.tax) {
      this.tax = new Tax(data.tax);
    }
  }
}
